export default {"src":"/_next/static/media/backward.6f70bf84.svg","height":18,"width":275,"blurWidth":0,"blurHeight":0};